import angular from 'angular'
import coverPage from './view/cover.html'

const contractCover = angular.module('app.input.electronImage.contractCover', [])

export default contractCover.name

class CoverCtrl {
    constructor($state, httpRequest, logger) {
        // this.$onInit = function init() {
        //     this.imageKey = host.etcloudPdf + this.contractInfo.coverContractFile.storageKey
        // }
        this.formFields = {}
        this.$onChanges = function onchanges() {
            this.imageKey = this.contractInfo && this.contractInfo.coverContractFile && host.etcloudPdf + this.contractInfo.coverContractFile.storageKey
            const formFields = this.contractInfo ? JSON.parse(this.contractInfo.dynamicKeyValue) : []
            this.formFields = formFields.sort((val1, val2) => {
                if (val1.position === undefined) {
                    return 1
                }
                if (val2.position === undefined) {
                    return -1
                }
                if (val1.position > val2.position) {
                    return 1
                }
                return -1
            })
        }
        this.saveCover = function saveCover() {
            let hasError = false
            this.formFields.forEach((item) => {
                if ((item.attri === '1' || item.attri === '2') && !item.value) {
                    item.hasError = true
                    hasError = true
                } else {
                    // hasError 字段不传给后台
                    delete item.hasError
                }
            })
            if (hasError) {
                return
            }
            this.contractInfo.dynamicKeyValue = JSON.stringify(this.formFields)
            httpRequest.post_updateContract(this.contractInfo).then(() => {
                logger.logSuccess('保存成功')
            })
        }
        this.cancel = function cancel() {
            $state.go('input.electronImage.contractEntering.list')
        }
    }
}

CoverCtrl.$inject = ['$state', 'httpRequest', 'logger']
contractCover.controller('contractCoverCtrl', CoverCtrl)
contractCover.component('contractCover', {
    template: coverPage,
    bindings: {
        contractInfo: '<',
        readonly: '<',
    },
    controller: 'contractCoverCtrl',
})



// WEBPACK FOOTER //
// ./src/app/input/electronImage/contractEntering/contractCover.js